// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chartkit-drill {
  display: flex;
  margin: 4px 0;
  margin-left: 16px;
  height: 24px;
  align-items: center;
}
.chartkit-drill__controls {
  height: 100%;
  display: flex;
  align-items: center;
}
.chartkit-drill__drill-action {
  cursor: pointer;
  display: inline-block;
  min-width: 16px;
}
.chartkit-drill__drill-action_left {
  transform: rotate(-90deg);
}
.chartkit-drill__drill-action_right {
  transform: rotate(90deg);
  margin-left: 12px;
}
.chartkit-drill__drill-action_disabled {
  cursor: default;
  fill: var(--g-color-text-secondary);
}
.chartkit-drill__breadcrumbs {
  width: calc(100% - 120px);
  align-items: center;
}
.chartkit-drill__separator {
  width: 1px;
  display: inline-block;
  height: 24px;
  margin: 0 12px;
  background-color: var(--g-color-line-generic);
}`, "",{"version":3,"sources":["webpack://./src/ui/libs/DatalensChartkit/components/Drill/Drill.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;AACJ;AACI;EACI,YAAA;EACA,aAAA;EACA,mBAAA;AACR;AAEI;EACI,eAAA;EACA,qBAAA;EACA,eAAA;AAAR;AAEQ;EACI,yBAAA;AAAZ;AAGQ;EACI,wBAAA;EACA,iBAAA;AADZ;AAIQ;EACI,eAAA;EACA,mCAAA;AAFZ;AAMI;EACI,yBAAA;EACA,mBAAA;AAJR;AAOI;EACI,UAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;EACA,6CAAA;AALR","sourcesContent":[".chartkit-drill {\n  display: flex;\n  margin: 4px 0;\n  margin-left: 16px;\n  height: 24px;\n  align-items: center;\n}\n.chartkit-drill__controls {\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n.chartkit-drill__drill-action {\n  cursor: pointer;\n  display: inline-block;\n  min-width: 16px;\n}\n.chartkit-drill__drill-action_left {\n  transform: rotate(-90deg);\n}\n.chartkit-drill__drill-action_right {\n  transform: rotate(90deg);\n  margin-left: 12px;\n}\n.chartkit-drill__drill-action_disabled {\n  cursor: default;\n  fill: var(--g-color-text-secondary);\n}\n.chartkit-drill__breadcrumbs {\n  width: calc(100% - 120px);\n  align-items: center;\n}\n.chartkit-drill__separator {\n  width: 1px;\n  display: inline-block;\n  height: 24px;\n  margin: 0 12px;\n  background-color: var(--g-color-line-generic);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
